/**
 * Shim for @clariness/radio-button: re-exports with optional pointer/crossOrigin props
 * so React 19 types don't require them (theme-ui Pick<> types treat them as required).
 */
import React from 'react';
import {
  RadioButton as OrigRadioButton,
  type RadioButtonProps,
} from '~clariness-radio-button';

type OptionalProps = {
  placeholder?: string;
  onPointerEnterCapture?: React.PointerEventHandler;
  onPointerLeaveCapture?: React.PointerEventHandler;
  crossOrigin?: string;
};

export type { RadioButtonProps };
export const RadioButton = OrigRadioButton as React.ForwardRefExoticComponent<
  Omit<React.ComponentProps<typeof OrigRadioButton>, keyof OptionalProps> &
    OptionalProps &
    React.RefAttributes<HTMLInputElement>
>;
